import { EmployeeData } from "../types/Employee";
import { patientApiUrl } from "./api";

const API_URL = "/employees";

export const getData = async (): Promise<EmployeeData[]> => {
  try {
    const res = await patientApiUrl.get<EmployeeData[]>(API_URL);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all employees error: ${
        error.response?.data?.message || error.message
      }`
    );
    return [];
  }
};
export const getEmployeeIdsData = async (): Promise<number[]> => {
  try {
    const res = await patientApiUrl.get<number[]>(`${API_URL}/employee-ids`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get employee ids error: ${
        error.response?.data?.message || error.message
      }`
    );
    return [];
  }
};
export const getDoctorIdsData = async (): Promise<number[]> => {
  try {
    const res = await patientApiUrl.get<number[]>(`${API_URL}/doctor-ids`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get doctor ids error: ${error.response?.data?.message || error.message}`
    );
    return [];
  }
};
export const getDataById = async (id: number): Promise<EmployeeData | null> => {
  try {
    const res = await patientApiUrl.get<EmployeeData>(`${API_URL}/${id}`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get employee error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const createData = async (
  data: Partial<EmployeeData>
): Promise<EmployeeData | null> => {
  try {
    const res = await patientApiUrl.post<EmployeeData>(API_URL, data);
    return res.data;
  } catch (error: any) {
    console.error(
      `Create employee error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const updateData = async (
  id: number,
  data: Partial<EmployeeData>
): Promise<EmployeeData | null> => {
  try {
    const res = await patientApiUrl.put<EmployeeData>(`${API_URL}/${id}`, data);
    return res.data;
  } catch (error: any) {
    console.error(
      `Update employee error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const deleteData = async (id: number): Promise<boolean> => {
  try {
    await patientApiUrl.delete(`${API_URL}/${id}`);
    return true;
  } catch (error: any) {
    console.error(
      `Delete employee error: ${error.response?.data?.message || error.message}`
    );
    return false;
  }
};
